import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Handle, Position } from 'reactflow';

import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { NODE_TYPES, nodeStyle } from '../constants';
import { ILiveChatDrawerData } from '../DrawerContents/LiveChatDrawer/interfaces';

function LiveChatNode(props) {
  const { data, selected, id } = props;

  const flowData = useSelector((state: RootState) => state?.flow);

  const [liveChatNodeData, setLiveChatNodeData] = useState<ILiveChatDrawerData>();

  // tracks the validity of the node and highlight invalid nodes
  const [isNodeValid, setIsNodeValid] = useState(true);
  const [nodeErrors, setNodeErrors] = useState<any>();

  useEffect(() => {
    // Find the flow object in the flowData array based on nodeId
    const flowObj = flowData.nodeConfigs.find((node) => node.nodeId === id);
    if (flowObj) {
      // Update the component state with liveChatSettings from the found flow object
      setLiveChatNodeData({ ...flowObj?.liveChatSettings });

      if (flowObj?.isValid !== undefined && flowObj?.isValid === false) {
        setIsNodeValid(false);
        setNodeErrors(flowObj?.errors);
      } else {
        setIsNodeValid(true);
        setNodeErrors([]);
      }
    }
  }, [flowData]);

  return (
    <div
      className={`bg-white p-1 rounded-md w-[250px] drop-shadow-lg opacity-80 ${
        selected ? 'border-2 border-[#93C5FD]' : ''
      } ${isNodeValid ? '' : 'border-2 border-red-500'} `}
    >
      <div>
        <div className="bg-orange-300 rounded-md px-2 py-1 text-center text-orange-600 font-semibold">
          {NODE_TYPES[data?.heading]?.label}
        </div>

        <div className="flow-node__content p-2 justify-center text-center">
          {!liveChatNodeData?.channelName ? (
            <span className="text-gray-500">Please assign a channel</span>
          ) : (
            <div className="flow-node__value">
              <span className="text-[#5c6a70] font-semibold">Linked Channel</span>
              <div className="mt-2">
                <span className="w-fit bg-gray-100 p-1 rounded">
                  {liveChatNodeData?.channelName}
                </span>
              </div>
            </div>
          )}
        </div>
        {data?.variableName && data?.validateAs && (
          <div className="p-2 m-1 border-2 border-dotted rounded-md border-gray w-1/2 justify-end">
            <p className="text-sm text-blue-400">User input</p>
            <span className="text-xs">
              {data?.validateAs}: {data?.variableName}
            </span>
          </div>
        )}
      </div>
      <div className="p-2 text-gainsboroBlue text-right">Continue</div>
      <Handle
        type="target"
        position={Position.Left}
        id={`live-chat-start-${id}`}
        className="!bg-blue-500"
        style={Position.Left && { ...nodeStyle, top: 18, left: -10 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id={`live-chat-end-${id}`}
        className="!bg-blue-500"
        style={{ ...nodeStyle, top: 'calc(100% - 18px)', right: -10 }}
      />
    </div>
  );
}

LiveChatNode.propTypes = {
  data: PropTypes.any,
  id: PropTypes.any,
  selected: PropTypes.bool,
};

export default LiveChatNode;
